export default ['apps', 'users', 'developers'];